import { AiWriterSidebarStep } from 'features/aiWriter/store/types';

export const mkInspirationStepTooltip = (step: AiWriterSidebarStep) => {
  return `aiWriter.inspirations.${step}.icon_tooltip`;
};
